import { render, staticRenderFns } from "./RecentWinners.vue?vue&type=template&id=1718e066&scoped=true"
import script from "./RecentWinners.vue?vue&type=script&lang=js"
export * from "./RecentWinners.vue?vue&type=script&lang=js"
import style0 from "./RecentWinners.vue?vue&type=style&index=0&id=1718e066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1718e066",
  null
  
)

export default component.exports